// extracted by css-extract-rspack-plugin
export default {"desktop_header":"nY4HI","desktopHeader":"nY4HI","mobile_header":"d_gAk","mobileHeader":"d_gAk","left":"MGWb5"};